module.exports = __webpack_public_path__ + "static/media/M1.060b3771.png";